import { combineReducers } from 'redux';
import servicesOfferedReducer from '../services_offered/reducers/services_offered_reducer';
import conditionsTreatedReducer from '../conditions_treated/reducers/conditions_treated_reducer';


export default combineReducers({
    servicesOfferedReducer,
    conditionsTreatedReducer
});